import { motion } from 'framer-motion';
import { ArrowDown, Camera } from 'lucide-react';

export const PersonalHero = ({ data }) => {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-amber-50 via-white to-rose-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 py-32 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* Text Content */}
        <div>
          <p className="text-amber-600 dark:text-amber-400 font-medium mb-6 tracking-wide">
            Hello, I'm
          </p>

          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-gray-900 dark:text-white mb-6 leading-tight">
            {data.name}
          </h1>

          <p className="text-xl sm:text-2xl text-gray-600 dark:text-gray-300 mb-8 leading-relaxed">
            {data.headline}
          </p>

          <p className="text-lg text-gray-600 dark:text-gray-400 mb-12 leading-relaxed max-w-xl">
            {data.introduction}
          </p>

          <div className="flex flex-wrap gap-4">
            {data.cta.map((button, index) => (
              <a
                key={index}
                href={button.href}
                className={`px-8 py-4 rounded-full font-medium transition-all duration-300 ${
                  index === 0
                    ? 'bg-amber-600 hover:bg-amber-700 text-white shadow-lg hover:shadow-xl'
                    : 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white border-2 border-gray-200 dark:border-gray-700 hover:border-amber-600 dark:hover:border-amber-600'
                }`}
              >
                {button.text}
              </a>
            ))}
          </div>
        </div>

        {/* Portrait */}
        <div className="relative">
          <div className="aspect-[3/4] bg-gradient-to-br from-amber-100 to-rose-100 dark:from-gray-700 dark:to-gray-600 rounded-3xl overflow-hidden shadow-2xl">
            <img 
              src="/images/hero-black-background-final.png" 
              alt="Vandana S." 
              className="w-full h-full object-cover"
            />
          </div>

          {/* Decorative elements */}
          <div className="absolute -z-10 top-8 -right-8 w-72 h-72 bg-amber-200 dark:bg-amber-900/20 rounded-full blur-3xl opacity-50" />
          <div className="absolute -z-10 -bottom-8 -left-8 w-72 h-72 bg-rose-200 dark:bg-rose-900/20 rounded-full blur-3xl opacity-50" />
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2">
        <div className="text-gray-400 dark:text-gray-500">
          <ArrowDown className="w-6 h-6 animate-bounce" />
        </div>
      </div>
    </section>
  );
};